import styled from 'styled-components';

export const LoadingToast = styled.div<{ active: boolean }>`
  position: absolute;
  background: #fff;
  bottom: 10px;
  opacity: ${p => (p.active ? '1' : '0')};
  padding: 5px 10px;
  border-radius: 3px;
  z-index: 999;
  display: flex;
  min-width: 150px;
  justify-content: center;
  align-items: center;
  left: 50%;
  transform: translate(-50%, ${p => (p.active ? '0' : '150%')});
  transition: 0.25s all ease-in-out;
  span {
    margin-left: 10px;
    font-weight: bold;
  }
`;
